import { html } from 'lit';
const NotionDuotone =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill="#000" d="M6.268 6.199c.568.46.78.426 1.845.355L18.16 5.95c.214 0 .036-.214-.035-.25l-1.668-1.205c-.32-.248-.746-.533-1.562-.462l-9.728.71c-.354.035-.425.213-.284.355zM6.87 8.54v10.569c0 .568.284.78.923.745l11.04-.638c.638-.035.71-.426.71-.887V7.83c0-.46-.178-.71-.568-.674L7.439 7.83c-.426.035-.568.248-.568.71m10.899.567c.07.319 0 .639-.32.675l-.533.106v7.802c-.462.249-.887.39-1.242.39-.568 0-.71-.177-1.136-.709l-3.48-5.462v5.285l1.102.248s0 .639-.889.639l-2.449.142c-.07-.142 0-.496.249-.568l.639-.177V10.49l-.888-.07c-.07-.32.107-.781.604-.817l2.627-.176 3.62 5.532v-4.893l-.923-.107c-.07-.39.214-.673.569-.71zM4.35 3.787l10.117-.745c1.242-.107 1.562-.035 2.343.532l3.23 2.27c.532.39.71.496.71.922v12.45c0 .78-.284 1.241-1.278 1.312l-11.75.71c-.745.035-1.1-.071-1.491-.568l-2.378-3.086c-.426-.568-.603-.993-.603-1.49V5.028c0-.639.283-1.17 1.1-1.241"/>
  </svg>
`;
export default NotionDuotone;
